"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_use_1 = require("react-use");
const Input_1 = tslib_1.__importDefault(require("reactstrap/lib/Input"));
exports.EditableTitleName = ({ name, disabled, onChange, }) => {
    const [editing, toggleEditing] = react_use_1.useToggle(false);
    // Input
    const inputRef = react_1.default.useRef(null);
    // useClickAway(inputRef, () => {
    //   if (editing) {
    //     toggleEditing(false);
    //   }
    // });
    // Focus on Input
    react_1.default.useEffect(() => {
        if (inputRef && inputRef.current && editing) {
            inputRef.current.focus();
        }
    }, [editing]);
    return !disabled && !editing ? (react_1.default.createElement("h2", { className: "cursor-pointer text-center font-weight-bold", onClick: () => {
            if (!disabled) {
                toggleEditing(true);
            }
        } }, name)) : (react_1.default.createElement(Input_1.default, { className: "text-center font-weight-bold", bsSize: "lg", value: name, onChange: e => {
            onChange(e.target.value);
        }, onKeyUp: e => {
            if (e.keyCode === 13) {
                e.preventDefault();
                toggleEditing(false);
            }
        }, onBlur: () => {
            toggleEditing(false);
        }, innerRef: inputRef }));
};
//# sourceMappingURL=EditableTitleName.js.map